// Deployment-wide evaluation scope shared by the Templates landing page
// (which owns the control) and the per-category pages (which read it).
// Mirrors the daemon's config.level values: "trace" judges each run once via
// its root span; "observation" judges every span in each trace.
export type EvaluationScope = "trace" | "observation";

export const GLOBAL_SCOPE_STORAGE_KEY = "monitor_scope";

export const scopeLabel = (scope: EvaluationScope) =>
  scope === "observation" ? "All spans" : "Run only (root span)";

export const describeTargetScope = (
  level: string | null | undefined,
  fallback: EvaluationScope
) =>
  level === "observation"
    ? "All spans"
    : level === "trace"
      ? "Run only (root span)"
      : `${scopeLabel(fallback)} (default)`;

export const isEvaluationScope = (value: unknown): value is EvaluationScope =>
  value === "trace" || value === "observation";

export const readStoredScope = (): EvaluationScope => {
  try {
    const stored = window.localStorage.getItem(GLOBAL_SCOPE_STORAGE_KEY);
    return stored === "observation" ? "observation" : "trace";
  } catch {
    // Storage can be blocked (private mode); fall back to the built-in default.
    return "trace";
  }
};

export const storeScope = (scope: EvaluationScope) => {
  try {
    window.localStorage.setItem(GLOBAL_SCOPE_STORAGE_KEY, scope);
  } catch {
    // Storage unavailable; the in-memory scope still applies this session.
  }
};
